import map from 'lodash/map';

const cloneAgents = agents =>
  map(agents, ({ id, owner, owners, name }) => ({
    id,
    owner,
    owners,
    name,
  }));

export default function convertPayloadToIntegration(integration, payload) {
  const {
    agents,
    id,
    plan,
    form,
    name,
    operation,
    type,
    triggeredBy,
    deployed,
    environment,
    script,
    integrationService,
    integrationServiceSelector,
    appendToUrl,
    loggingLevel,
    endpoint,
    createdBy,
  } = payload;

  return {
    ...integration,
    agents: agents ? cloneAgents(agents.data) : [],
    id,
    plan: { id: plan ? plan.id : null },
    form: { id: form ? form.id : null },
    name,
    operation,
    type,
    triggeredBy,
    endpoint: {
      id: endpoint ? endpoint.id : null,
    },
    deployed,
    environment,
    // xm-api requires IO to be base64 encoded, so decode if it exists:
    script: script ? atob(script) : script,
    integrationService,
    integrationServiceSelector,
    appendToUrl,
    loggingLevel,
    isOnPremiseWithNoAgent: !agents,
    createdBy: createdBy || integration.createdBy,
  };
}
